import React from "react";
import { 
  LandingLayout, 
  HeroSection, 
  FeaturesSection, 
  DemoSection, 
  PortalsSection 
} from "./landing/index";

const Landing = () => {
  return (
    <LandingLayout>
      <HeroSection />
      <FeaturesSection />
      <DemoSection />
      <PortalsSection />
    </LandingLayout>
  );
};

export default Landing;
